<template>
  <div class="unit-tracking-card">
    <h6 class="unit-tracking-card__title">Unit Utilization</h6>
    <div v-if="loading" class="text-center py-2"><i class="fa fa-spinner fa-spin"></i></div>
    <div v-else>
      <!-- Current Month Usage -->
      <div v-if="Object.keys(currentMonthUsage).length > 0" class="unit-tracking-card__section">
        <p class="unit-tracking-card__section-title">Current Month</p>
        <div v-for="(usage, code) in currentMonthUsage" :key="code" class="unit-tracking-card__code-row">
          <span class="unit-tracking-card__code">{{ code }}</span>
          <span class="unit-tracking-card__usage">{{ usage.units }} units ({{ usage.hours.toFixed(1) }}h)</span>
        </div>
      </div>

      <!-- Authorization Breakdown -->
      <div v-for="auth in authorizations" :key="auth.authId" class="unit-tracking-card__auth">
        <div class="unit-tracking-card__auth-header">
          <span>{{ auth.serviceCode || 'Auth' }} #{{ auth.authNumber || auth.authId }}</span>
          <span class="unit-tracking-card__auth-remaining">{{ auth.remainingUnits }} remaining</span>
        </div>
        <el-progress
          :percentage="getUsagePercent(auth)"
          :color="getProgressColor(auth)"
          :stroke-width="12"
          :show-text="false"
        />
        <div class="unit-tracking-card__auth-detail">
          {{ auth.usedUnits }} / {{ auth.totalUnits }} units used
          <span v-if="auth.unitType">({{ auth.unitType }})</span>
        </div>
      </div>

      <div v-if="authorizations.length === 0 && Object.keys(currentMonthUsage).length === 0" class="text-center" style="color: #b3a6a6; font-size: 0.85rem;">
        No unit data available.
      </div>
    </div>
  </div>
</template>

<script>
import CommonAPIService from "@/serviceHandlers/commonHandler";
import router from "src/routes/routes";

const api = new CommonAPIService(router);

export default {
  name: "UnitTrackingCard",
  props: {
    clientId: { type: Number, required: true },
  },
  data() {
    return {
      currentMonthUsage: {},
      authorizations: [],
      loading: false,
    };
  },
  watch: {
    clientId: {
      immediate: true,
      handler(val) { if (val) this.fetch(); },
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      try {
        const result = await api.getCall(`/api/clients/${this.clientId}/unit-summary`);
        this.currentMonthUsage = result.currentMonthUsage || {};
        this.authorizations = result.authorizations || [];
      } catch {
        this.currentMonthUsage = {};
        this.authorizations = [];
      } finally {
        this.loading = false;
      }
    },
    getUsagePercent(auth) {
      if (!auth.totalUnits || auth.totalUnits === 0) return 0;
      return Math.min(100, Math.round((auth.usedUnits / auth.totalUnits) * 100));
    },
    getProgressColor(auth) {
      const pct = this.getUsagePercent(auth);
      if (pct >= 90) return "#f56c6c";
      if (pct >= 75) return "#e6a23c";
      return "#67c23a";
    },
  },
};
</script>

<style scoped>
.unit-tracking-card { background: rgba(37, 55, 65, 0.95); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 8px; padding: 1rem; }
.unit-tracking-card__title { color: #fff; margin-bottom: 0.75rem; }
.unit-tracking-card__section { margin-bottom: 1rem; }
.unit-tracking-card__section-title { color: #b3a6a6; font-size: 0.8rem; margin-bottom: 0.5rem; }
.unit-tracking-card__code-row { display: flex; justify-content: space-between; padding: 0.2rem 0; }
.unit-tracking-card__code { color: #447DF7; font-weight: 600; font-size: 0.9rem; }
.unit-tracking-card__usage { color: #e0e0e0; font-size: 0.85rem; }
.unit-tracking-card__auth { margin-bottom: 1rem; }
.unit-tracking-card__auth-header { display: flex; justify-content: space-between; color: #e0e0e0; font-size: 0.85rem; margin-bottom: 0.25rem; }
.unit-tracking-card__auth-remaining { color: #67c23a; font-weight: 600; }
.unit-tracking-card__auth-detail { color: #b3a6a6; font-size: 0.8rem; margin-top: 0.25rem; }
</style>
